import React from 'react'

const getNodes: any = str => new DOMParser().parseFromString(str, 'text/html').body.childNodes
const createJSX: any = (nodeArray: any, style: React.CSSProperties) => {

    return nodeArray.map(node => {
        const attributeObj = {}
        const { attributes, localName, childNodes, nodeValue } = node
        if (attributes) {
            Array.from(attributes).forEach((attribute: any) => {
                if (
                    attribute.name !== 'fill' &&
                    attribute.name !== "theme['auxiliar-typography']}" &&
                    attribute.name !== '||'
                ) {
                    if (attribute.name === 'style') {
                        const styleAttributes = attribute.nodeValue.split(';')
                        const styleObj = {}
                        styleAttributes.forEach(attribute => {
                            const [key, value] = attribute.split(':')
                            styleObj[key] = value
                        })
                        attributeObj[attribute.name] = styleObj
                    } else {
                        attributeObj[attribute.name] = attribute.nodeValue
                    }
                }
            })
        }
        if (style) {
            // eslint-disable-next-line dot-notation
            attributeObj['style'] = style
        }
        return localName
            ? React.createElement(
                  localName,
                  attributeObj,
                  childNodes && Array.isArray(Array.from(childNodes)) ? createJSX(Array.from(childNodes)) : []
              )
            : nodeValue
    })
}

interface IProps {
    domString: string
    style: React.CSSProperties
}

/**
 * @description This is used to transform text into JSX Element, common uses are SVG images from text
 * @param props {domString: string}  domString is the string containing your HTML
 * @returns JSX.Element returns a react element.
 */
export const StringToJSX = (props: IProps): JSX.Element => {
    return createJSX(Array.from(getNodes(props.domString)), props.style)
}
